(function () {
    'use strict';

    /**
     * Speakers section (Speakers / SpeakersAll / SpeakersKeynote / SpeakersFeatured / Organizers / Committee) - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_Speakers.cshtml),
     * the attribute value is the speakers type to load.
     * No template and a child scope, so the Razor markup inside binds to "speakersSection"
     * and still sees the page "vm" (getStyle, showLoading, showSpeaker, showSpeakerCountry, isRTL, repeatEnd).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionSpeakers', sectionSpeakers);

    function sectionSpeakers() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionSpeakersCtrl,
            controllerAs: 'speakersSection'
        };
    }

    SectionSpeakersCtrl.$inject = ['$element', '$attrs', 'ApiFactory', 'Constants', 'SectionRegistry'];

    function SectionSpeakersCtrl($element, $attrs, ApiFactory, Constants, SectionRegistry) {
        const vm = this;
        const EventListSections = Constants.EventListSections;
        vm.lists = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * css class of a speaker card
         * @param {number} length number of speakers in the category
         * @param {number} index
         * @param {any} hasSideImage
         * @returns {string}
         */
        vm.itemClass = function (length, index, hasSideImage) {
            if (length == 0 || length == undefined)
                return '';

            let cssClass = 'pt-3 ';
            if (hasSideImage)
                cssClass += 'col-sm-12 col-md-6';
            else
                cssClass += 'col-sm-6 col-md-3';

            return cssClass;
        };

        /**
         * Load the speakers of the section type
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise<boolean>} true when data was received
         */
        function load(eventId, lang) {
            const type = $attrs.wsSectionSpeakers;
            if (type == EventListSections.SpeakersAll) {
                return ApiFactory.GetAllSpeakers(eventId, lang).then(function (response) {
                    if (response.data)
                        vm.lists = response.data;

                    return true;
                });
            }

            return getSpeakers(type, eventId, lang).then(function (response) {
                if (response.data == null)
                    return false;

                if (response.data.length > 0)
                    vm.lists = response.data;

                return true;
            });
        }

        function getSpeakers(type, eventId, lang) {
            switch (type) {
                case EventListSections.SpeakersKeynote:
                    return ApiFactory.GetKeynoteSpeakers(eventId, lang);
                case EventListSections.SpeakersFeatured:
                    return ApiFactory.GetFeaturedSpeakers(eventId, lang);
                case EventListSections.Organizers:
                    return ApiFactory.GetOrganizerSpeakers(eventId, lang);
                case EventListSections.Committee:
                    return ApiFactory.GetCommitteeSpeakers(eventId, lang);
                default:
                    return ApiFactory.GetSpeakers(eventId, lang);
            }
        }
    }
})();
